import type {ImageLoaderProps} from "next/image";

const normalizeSrc = (src: string) => {
  return src.startsWith("/") ? src.slice(1) : src;
};

// Define the domain for R2 images (customize accordingly)
const R2_DOMAIN = process.env.NEXT_PUBLIC_R2_PUBLIC_URL;

// Optionally, you might define a prefix for R2 images so that your system knows which source type you're using.
const R2_PREFIX = "r2:";

export default function cloudflareLoader({src, width, quality}: ImageLoaderProps) {
  if (src.startsWith(R2_PREFIX)) {
    const params = [
      `width=${width}`,
      "format=auto", // let CF pick AVIF/WebP/JPEG
      quality ? `quality=${quality}` : "quality=auto"
    ].join(",");

    return `${R2_DOMAIN}/cdn-cgi/image/${params}/${normalizeSrc(src.slice(R2_PREFIX.length))}`;
  }
  return `${src}?w=${width}&q=${quality || 75}`;
}
